/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="41" height="41" viewBox="0 0 41 41" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <g>
      <g>
        <path d="M21.5,40a19.5,19.5,0,0,0,0-39,19.7,19.7,0,0,0-4.7.57A19.5,19.5,0,0,0,21.5,40Z" transform="translate(-1)" fill="#edf0f3" stroke="#fff" fillRule="evenodd" strokeWidth="2px"/>
        <circle cx="20.5" cy="20.5" r="15.5" fill="none" stroke="#ffb81c" strokeWidth="0.75px"/>
      </g>
      <g>
        <g>
          <path d="M21.25,11.07a12.08,12.08,0,0,1-8,2.95.26.26,0,0,0-.26.26v3.16a27.07,27.07,0,0,0,.18,3.4l0,.28A13.1,13.1,0,0,0,14.34,25a11.4,11.4,0,0,0,7,5.82.28.28,0,0,0,.18,0,11.4,11.4,0,0,0,7-5.82,14.84,14.84,0,0,0,1.31-6v-.32c0-.16,0-.32,0-.48v-4A.26.26,0,0,0,29.6,14a12.08,12.08,0,0,1-8-2.95A.27.27,0,0,0,21.25,11.07Zm.18.54,0,0a12.56,12.56,0,0,0,7.8,2.89h.06v3.74A15.23,15.23,0,0,1,28,24.81l-.05.11a10.87,10.87,0,0,1-6.51,5.39l-.05,0,.09,0a10.88,10.88,0,0,1-6.7-5.55l-.05-.11a13.84,13.84,0,0,1-1.17-5l0-.3c0-.35,0-.72,0-1.1V14.53h.06a12.56,12.56,0,0,0,7.8-2.89Z" transform="translate(-1)" fill="#0e497b"/>
        </g>
      </g>
    </g><g>
      <path d="M23.5,18a2.61,2.61,0,0,0-1.69.63l-.31.27-.31-.27A2.61,2.61,0,0,0,19.46,18a2.66,2.66,0,0,0-1.79.67,2,2,0,0,0,.08,3.06L21.42,25a.12.12,0,0,0,.16,0l3.67-3.24a2,2,0,0,0,.08-3.06A2.66,2.66,0,0,0,23.54,18Z" transform="translate(-1)" fill="#ffb81c"/>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'ShieldWithHeartBorderIcon';

export default Icon;
